import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);


const StatsProductWarehouseCategory = ({ data }) => {
  const brandQuantities = data?.reduce((acc, product) => {
    const brand = product.categoryName;
    acc[brand] = (acc[brand] || 0) + product.totalQuantity;
    return acc;
  }, {});
  const quantityData = {
    labels: Object.keys(brandQuantities),
    datasets: [
      {
        label: 'Quantité',
        data: Object.values(brandQuantities),
        backgroundColor: [
          'rgba(255, 99, 132, 0.8)',
          'rgba(54, 162, 235, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(153, 102, 255, 0.8)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const doughnutOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: 'Quantité par Catégorie',
      },
    },
  };

  return (

    <div class="card">
      <div class="card-header border-0">
        <h3 class="card-title">
          <h5>Statistique par Catégorie</h5>

        </h3>
        {/* card tools */}
        <div className="card-tools">

          <button type="button" className="btn btn-sm" data-card-widget="collapse" data-toggle="tooltip" title="Collapse">
            <i className="fas fa-minus" />
          </button>
        </div>
      </div>
      {/* /.card-tools */}

      <div class="card-body">

        <div className="brand-charts">

          <div className="charts-container">
            {/* Quantity by Brand - Bar Chart */}
           

                <Doughnut data={quantityData} options={doughnutOptions} />


           
          </div>

          {/* Summary Statistics */}

        </div>
      </div></div>
  )



}
export default StatsProductWarehouseCategory;